// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QSIa-","importantInfo":"styles_importantInfo__3j9I8"};